import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import classNames from 'classnames';
import Sidebar from 'components/Sidebar';
import Navbar from 'components/Navbars';
import { dashboardRoutes } from 'routes';
import { useAppDispatch, useAppSelector } from 'helpers/hooks';
import { getSubscriptionLevel } from 'selectors/partners';
import { getIsRecipient } from 'config/permissions';
import { useAdminAuth } from 'hooks/useAdminAuth';
import { getPartners } from 'store/partners/actions';

const DashboardLayout = () => {
  const dispatch = useAppDispatch();
  const mainPanel = useRef<HTMLDivElement>(null);
  const { clientId, activeRole, hasClient } = useAdminAuth();
  const subscriptionLevel = useAppSelector(getSubscriptionLevel);
  const isRecipient = getIsRecipient(activeRole);

  useEffect(() => {
    if (hasClient && clientId) {
      dispatch(getPartners({ search_str: clientId, partner_ids: [] }, activeRole));
    }
  }, [hasClient, clientId, activeRole, dispatch]);

  return (
    <div className={classNames('wrapper', { 'wrapper--recipient': isRecipient })}>
      <Sidebar
        routes={dashboardRoutes}
        activeRole={activeRole}
        subscriptionLevel={subscriptionLevel}
      />
      <div className="main-panel" ref={mainPanel}>
        <Navbar activeRole={activeRole} />
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
